import { render, staticRenderFns } from "./DefaultCommunicationChannels.vue?vue&type=template&id=f624efb6&scoped=true&"
import script from "./DefaultCommunicationChannels.vue?vue&type=script&lang=js&"
export * from "./DefaultCommunicationChannels.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCommunicationChannels.vue?vue&type=style&index=0&id=f624efb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f624efb6",
  null
  
)

export default component.exports